import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18next';
import Row from '../Row';
import Column from '../Column';
import { OPEN_CHAT_WINDOW } from '../ChatWindow/actions';
import TextWithLinks from '../../../utils/TextWithLinks';
import QuestionBoxContainer from './css';

const QuestionsBlock = ({ link, ...props }) => {
  const linkSettings = [
    {
      id: 'chatWithUs',
      href: null,
      target: null,
      action: props.openChatWindow,
      label: t('QuestionBlockChatLink'),
      aria: t('QuestionBlockChatLink'),
    },
    {
      id: 'supportPage',
      href: '/support',
      target: '_blank',
      action: null,
      aria: t('QuestionBlockSupportPageLink'),
      label: t('QuestionBlockSupportPageLink'),
    },
  ];

  return (
    <section aria-labelledby={t('QuestionsBlockTitle')}>
      <Row>
        <Column $mobile={12}>
          <QuestionBoxContainer className="text-center">
            <h2 className="mb-4">{t('QuestionsBlockTitle')}</h2>
            <TextWithLinks text={t('QuestionsBlockDescription')} links={linkSettings} />
          </QuestionBoxContainer>
        </Column>
      </Row>
    </section>
  );
};

QuestionsBlock.propTypes = {
  link: PropTypes.any,
  openChatWindow: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  openChatWindow: () => dispatch({ type: OPEN_CHAT_WINDOW }),
});

export default connect(null, mapDispatchToProps)(QuestionsBlock);
